import {AfterViewInit, DestroyRef, Directive, ElementRef, inject, Renderer2} from '@angular/core';
import {WindowResizeService} from '../../services/window-resize.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

const DEFAULT_STYLES = {
  'text-overflow': 'ellipsis',
  overflow: 'hidden',
  'white-space': 'nowrap',
} as const;

@Directive({
  selector: '[msShowTooltipIfTruncated]',
  exportAs: 'msShowTooltipIfTruncated',
  standalone: true,
})
export class ShowTooltipIfTruncatedDirective implements AfterViewInit {
  private readonly renderer = inject(Renderer2);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly windowResizeService = inject(WindowResizeService);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    for (const [style, value] of Object.entries(DEFAULT_STYLES)) {
      this.renderer.setStyle(this.elementRef.nativeElement, style, value);
    }
    this.windowResizeService.resize$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.togglePointerEvents();
    });
  }

  ngAfterViewInit(): void {
    this.togglePointerEvents();
  }

  togglePointerEvents(): void {
    const element = this.elementRef.nativeElement;
    const doesTextFitContent = element.offsetWidth >= element.scrollWidth;

    this.renderer.setStyle(element, 'pointer-events', doesTextFitContent ? 'none' : 'auto');
  }
}
